import { Area, AreaChart, ResponsiveContainer, Line, LineChart, XAxis, YAxis, Tooltip } from "recharts";
import { Panel, Eyebrow } from "@/components/mh/bits";

const Kpi = ({ k, hex }) => (
  <div className="rounded-lg border border-white/[0.06] bg-white/[0.02] p-3 min-w-0">
    <div className="text-[11px] text-muted-foreground truncate">{k.label}</div>
    <div className="flex items-baseline gap-2 mt-1">
      <span className="font-display text-2xl tabular-nums">{k.value}</span>
      <span className="font-mono text-[10px]" style={{ color: String(k.delta).startsWith("-") ? "#FF3B5C" : "#D4FF3A" }}>{k.delta}</span>
    </div>
    <div className="h-8 mt-1">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={k.sparkline}><Line type="monotone" dataKey="v" stroke={hex} strokeWidth={1.5} dot={false} isAnimationActive={false} /></LineChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export const CommandCenter = ({ board, hex }) => {
  const maxB = Math.max(...(board.breakdown || []).map((b) => b.value), 1);
  const gid = `g-${board.slug}`;
  return (
    <Panel cls="p-5" testId={`command-center-${board.slug}`}>
      <Eyebrow>Command center</Eyebrow>
      <h3 className="font-display text-2xl mt-1.5">{board.name}</h3>
      <p className="text-sm text-muted-foreground">{board.subtitle}</p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 mt-4">
        {board.kpi_tiles.map((k) => <Kpi key={k.label} k={k} hex={hex} />)}
      </div>
      <div className="h-40 sm:h-48 mt-4 -mx-2">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={board.timeseries}>
            <defs><linearGradient id={gid} x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor={hex} stopOpacity={0.35} /><stop offset="100%" stopColor={hex} stopOpacity={0} /></linearGradient></defs>
            <XAxis dataKey="t" hide /><YAxis hide />
            <Tooltip contentStyle={{ background: "#0A0A0F", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 8, fontSize: 12 }} />
            <Area type="monotone" dataKey="primary" stroke={hex} fill={`url(#${gid})`} strokeWidth={2} />
            <Area type="monotone" dataKey="secondary" stroke="rgba(255,255,255,0.35)" fill="transparent" strokeDasharray="4 4" strokeWidth={1.2} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-3">
        <div className="space-y-2">
          {(board.breakdown || []).map((b) => (
            <div key={b.label}>
              <div className="flex justify-between text-xs"><span>{b.label}</span><span className="font-mono text-muted-foreground">{b.value}</span></div>
              <div className="h-1 mt-1 rounded-full bg-white/[0.06]"><div className="h-full rounded-full" style={{ width: `${(b.value / maxB) * 100}%`, background: hex }} /></div>
            </div>
          ))}
        </div>
        <ul className="space-y-1.5">
          {board.signals.map((s) => <li key={s} className="text-sm flex gap-2"><span className="mt-1.5 w-1 h-1 rounded-full flex-shrink-0" style={{ background: hex }} />{s}</li>)}
        </ul>
      </div>
    </Panel>
  );
};
